import useSWRImmutable from 'swr/immutable';
import type { ICMSWageringByVolatility } from '@/api/cms/wageringByVolatility';
import { getWageringByVolatilityUrl } from '@/api/cms/wageringByVolatility';
import { fetcherCMS } from '@/modules/api';
import { useMatchingSections } from '@/modules/restrictions/hooks/useAccessSections';
import { parseVolatilityPattern } from '../helpers/volatilityPattern';

const NO_PATTERNS: ICMSWageringByVolatility[] = [];

export const useVolatilityPattern = (enabled: boolean) => {
  const { data, error } = useSWRImmutable<ICMSWageringByVolatility[]>(
    enabled ? getWageringByVolatilityUrl() : null,
    fetcherCMS
  );

  const [active] = useMatchingSections(data ?? NO_PATTERNS);

  return {
    pattern: active ? parseVolatilityPattern(active.gridGames) : undefined,
    isResolved: !enabled || data !== undefined || error !== undefined,
  };
};
